<template lang="pug">
.category-page-list
    tabs(:items="tabs" :active-tab="$route.fullPath" @click="activateTab")
    el-card.contains-table(shadow="always")
        //- TODO
        //- save active columns for every category individually
        //- must be fixed in database first..
        //- API does not allow dynamic keys
        //- :type="key"
        .error(v-if="error")
            template(v-if="error.code")
                Error(:message="$t(error.message || 'Something went wrong!')" :code="error.code")
            template(v-else)
                Error(:message="$t('Something went wrong!')" :code="501")
        .pages-table(v-else)
            paginated-items(
                scope="cp"
                type="page"
                :loading="loading"
                :items="categoryPagesPaginated.items"
                :row-link-config="categoryPagesPaginated.link"
                :filters="filters"
                :show-filters="showFilters"
                :variables="categoryPagesPaginated.variables"
                :all-columns="categoryPagesPaginated.allColumns"
                :active-columns="categoryPagesPaginated.activeColumns"
                :page-info="categoryPagesPaginated.pageInfo"
                :sort="sort"
                @pagination-size-change="handleSizeChange"
                @pagination-current-change="handleCurrentChange"
                @show-table-columns="handleColsShow"
                @change-filter="handleFilterInputChange"
                @change-sort="handleSortInputChange"
            )
                template(v-slot:title="{ item, value }")
                    .post-title-with-status
                        el-tooltip(effect="dark" :content="postStatusLabel(item)" placement="top")
                            span.status-dot(:class="postStatusClass(item)")
                        span {{ value }}
                template(v-slot:actions="{ item }")
                    el-tooltip(effect="dark" :content="$t('Delete post')" placement="top")
                        el-button(
                            plain
                            circle
                            size="mini"
                            type="danger"
                            icon="el-icon-fa-trash-alt far"
                            @click.stop.prevent="confirmDeletePost(item)"
                        )
                    el-tooltip(effect="dark" :content="$t('Preview post')" placement="top")
                        el-button(
                            plain
                            circle
                            size="mini"
                            type="info"
                            icon="el-icon-fa-eye far"
                            :disabled="!getPostPublicUrl(item)"
                            @click.stop.prevent="openPostPreview(item)"
                        )
                    el-tooltip(effect="dark" :content="$t('Copy post link')" placement="top")
                        el-button(
                            plain
                            circle
                            size="mini"
                            type="primary"
                            icon="el-icon-fa-copy far"
                            :disabled="!getPostPublicUrl(item)"
                            @click.stop.prevent="copyPostLink(item)"
                        )
                template(slot="top")
                    el-row.table-top(v-loading="loading" type="flex" justify="space-between")
                        .left
                            el-button(
                                v-if="allowedToCreate"
                                type="primary"
                                size="mini"
                                icon="el-icon-fa-plus fas"
                                @click="addCategoryPage"
                            )
                                | {{ $t('New category post') }}
                        .right
                            el-button.right(
                                v-if="allowedToCreate"
                                plain
                                type="primary"
                                size="mini"
                                icon="el-icon-fa-pencil fas"
                                @click="openNewFilterModal"
                            )
                                | {{ $t('manage category filters for "{name}"', { name: this.currentFilterName }) }}
                            el-button(
                                plain
                                size="mini"
                                type="primary"
                                icon="el-icon-fa-filter fas"
                                @click="toggleFilterVisiblity"
                                :disabled="disable.showFilters || hasFilters"
                            )
                                span(v-if="showFilters") {{ $t('Hide filters') }}
                                span(v-else) {{ $t('Show filters') }}

    el-dialog.new-filter-dialog(
        :title="$t('Manage category filters')"
        :visible.sync="filtersModal.visibility"
        :close-on-click-modal="false"
        top="10vh"
        width="700px"
        @closed="resetFiltersModal"
    )
        el-form.filter-modal-form(
            ref="filtersModal"
            :model="filtersModal.form"
            label-position="top"
            :rules="newFilterRules"
            v-loading="filtersModal.loading"
            @submit.prevent.native="appendFilterItem"
        )
            transition(name="slide-vertical")
                .modal-body(v-if="! filtersModal.loading")
                    .alert.mt-0
                        b {{ $t('Info') }}
                        p {{ $t('All filters that are defined here can then be used in the individual posts.') }}
                    template(v-if="categoryFilters.length > 0")
                        label.mb-1 {{ $t('Existing filters') }}
                        .category-filters
                            el-tag(
                                v-for="filter in categoryFilters"
                                :key="filter.key"
                                :type="filtersModal.remove.includes(filter) ? 'danger' : 'primary'"
                                closable
                                :disable-transitions="false"
                                @close="toggleFilterRemoval(filter)"
                            ) {{ filter.name }}
                    el-form-item.no-margin(:label="$t('Add a new filter')" prop="filter.name")
                        el-input(
                            class="input-new-tag"
                            v-model="filtersModal.form.filter.name"
                            @keyup.enter.native="appendFilterItem"
                            @blur="appendFilterItem"
                        )
                        //- el-col(:sm="12")
                        //-     template
                                //- el-form-item(:label="$t('URL Key')" prop="item.path")
                                //-     el-input(v-model="filtersModal.form.filter.path" autocomplete="off")
                                        // template(slot="prepend") /
                .modal-body(v-else)
                    el-row.no-margin
                        el-alert.delete-warning(
                            :closable="false"
                            type="warning"
                            :description="$t('Filters could not be fetched!')"
                        )
        template(slot="footer")
            el-alert.delete-warning(
                v-if="filtersModal.remove.length > 0"
                :closable="false"
                :title="$t('Attention!')"
                type="error"
                effect="light"
                :center="false"
                :description="$t('When you delete a filter, all related values inside posts will also be deleted!')"
            )

            el-button.pull-left(
                :disabled="filtersModal.remove.length <= 0"
                type="danger"
                @click="removeFilters"
            ) {{ $t('Delete filters') }}
            el-button(
                :disabled="filtersModal.loading"
                type="primary"
                @click="closeNewFilterModal"
            ) {{ $t('Close') }}

    PreviewDrawer(
        :visible.sync="previewDrawer.visibility"
        :src="previewDrawer.src"
        :loading="previewDrawer.loading"
        @closed="resetPreviewModal"
    )
</template>

<i18n>
{
    "de": {
        "New category post": "Neuer Kategoriebeitrag",
        "New category filter": "Neuer Kategoriefilter",
        "manage category filters for \"{name}\"": "Kategoriefilter für \"{name}\" verwalten",
        "Add category filter": "Neuer Kategoriefilter hinzufügen",
        "Show filters": "Filter anzeigen",
        "Hide filters": "Filter verbergen",
        "Post list could not be fetched.": "Beitragsliste konnte nicht abgerufen werden.",
        "Category filters could not be fetched.": "Kategorfilter konnten nicht geladen werden.",
        "Close": "Schließen",
        "Category filter": "Kategoriefilter",
        "Manage category filters": "Kategoriefilter verwalten",
        "Category filter was deleted successfully.": "Kategoriefilter erfolgreich gelöscht.",
        "Category filter was added successfully.": "Kategoriefilter erfolgreich hinzugefügt.",
        "Update successfull!": "Erfolgreich aktualisiert!",
        "Category filter could not be saved.": "Kategoriefilter konnten nicht gespeichert werden.",
        "Category filter already exists.": "Kategoriefilter existiert bereits.",
        "Add a new filter": "Neuen Filter hinzufügen",
        "Existing filters": "Vorhandene Filter",
        "Delete filters": "Filter löschen",
        "Attention!": "Achtung!",
        "Info": "Info",
        "All filters that are defined here can then be used in the individual posts.": "Alle hier definierten Filter können in den einzelnen Beiträgen verwendet werden",
        "When you delete a filter, all related values inside posts will also be deleted!": "Wenn Sie einen Filter löschen, werden alle dazu eingetragenen Werte in den Beiträgen ebenfalls gelöscht!",
        "Filters could not be fetched!": "Filter konnten nicht geladen werden!",
        "Preview post": "Vorschau Beitrag",
        "Copy post link": "Beitragslink kopieren",
        "Post link copied to clipboard!": "Beitragslink wurde in die Zwischenablage kopiert!",
        "Post link could not be copied.": "Beitragslink konnte nicht kopiert werden.",
        "Active": "Aktiv",
        "Inactive": "Inaktiv",
        "Delete post": "Beitrag löschen",
        "Delete": "Löschen",
        "Cancel": "Abbrechen",
        "Do you really want to delete \"{title}\"?": "Möchten Sie „{title}“ wirklich löschen?",
        "Post deleted successfully.": "Beitrag erfolgreich gelöscht.",
        "Post could not be deleted.": "Beitrag konnte nicht gelöscht werden."
    },
    "en": {
        "manage category filters for \"{name}\"": "manage category filters for \"{name}\"",
        "Do you really want to delete \"{title}\"?": "Do you really want to delete \"{title}\"?"
    }
}
</i18n>

<script>
import _ from 'lodash';
import copy from 'copy-text-to-clipboard';
import { adminClient as apolloClient } from '@/store/apollo';

import router from '@/router';
import pinia from '@/pinia'
import { useAuthStore, useSetupStore, usePageStore } from '@/stores'

import uniqid from 'uniqid';
import slugify from 'slugify';

import CategoryFiltersAPI from '@/store/api/cms/categoryFilter';
import PageApi from '@/store/api/cms/page';

import PaginatedItems from '@/components/PaginatedItems';
import Tabs from '@/components/Tabs';
import Error from '@/components/Error';
import PreviewDrawer from '@/components/PreviewDrawer';

export default {
    name: 'CategoryPages',
    data() {
        return {
            error: false,
            right: 'cp:posts',
            disable: {
                showFilters: false,
            },
            filtersModal: {
                visibility: false,
                loading: false,
                remove: [],
                form: {
                    filters: [],
                    filter: {
                        name: '',
                        key: ''
                    }
                }
            },
            previewDrawer: {
                visibility: false,
                src: undefined,
                loading: false
            }
        };
    },
    components: {
        PaginatedItems,
        Error,
        Tabs,
        PreviewDrawer
    },
    watch: {
        activeCms(cms) {
            const reload = _.get(cms, 'reloadComponents', true);
            if (reload) this.initialize();
        }
    },
    computed: {
        key() {
            // const route = router.history.current
            // const key = _.get(route, 'meta.key')
            //
            // return key

            return this.$route.params.key;
        },
        newFilterRules() {
            let rules = {
                // filter: {
                //     name: 'required',
                //     key: 'required',
                // }
            };

            return rules;
        },
        currentFilterName() {
            let name = 'undefined';
            const currentCategory = this.categories.find( category => category.key === this.key );
            if ( currentCategory && currentCategory.name ) name = currentCategory.name;
            return name;
        },
        currentCategory() {
            return this.categories.find( category => category.key === this.key );
        },
        showFilters() {
            return this.hasFilters || _.get(this.categoryPagesPaginated, 'showFilters') || false;
        },
        hasFilters() {
            return !_.isEmpty(this.filters);
        },
        filters() {
            let filters = _.cloneDeep(this.categoryPagesPaginated.filters);
            delete filters.category_key;
            delete filters.cms;
            return filters;
        },
        sort() {
            var variables = this.categoryPagesPaginated.variables;
            var defaultSort = this.categoryPagesPaginated.defaultSort || { field: 'date', direction: 'desc' };
            var order = (variables.order !== undefined && variables.order !== '') ? variables.order : defaultSort.field;
            var direction = (variables.direction !== undefined && variables.direction !== '') ? variables.direction : defaultSort.direction;

            return { field: order, direction: direction };
        },
        categories() {
            const cms = this.activeCms;
            return _.get(cms, 'config.template.categories') || [];
        },
        categoryFilters() {
            return _.get(this.filtersModal.form, 'filters') || [];
        },
        tabs() {
            let tabs = [];
            this.categories.forEach(category => {
                tabs.push({
                    name: category.name,
                    path: `/posts/${category.key}`,
                    icon: {
                        name: 'newspaper',
                        group: 'far'
                    }
                });
            });

            return tabs;
        },
        allowedToCreate() {
            let allowed = true;
            if (! this.isSuperUser && ! this.isOwner) {
                allowed = this.rights.find(right => right.key === this.right && right.permission.access) // TMP
                // allowed = this.rights.find(right => right.key === this.right && right.permission.create)
            }
            return allowed;
        },
        isSuperUser() {
            return useAuthStore().isSuperUser;
        },
        isOwner() {
            return useAuthStore().isOwner;
        },
        rights() {
            return useAuthStore().rights;
        },
        activeCms() {
            return useSetupStore().activeCms;
        },
        debounce() {
            return useSetupStore().debounce;
        },
        pageStore() {
            return usePageStore();
        },
        loading() {
            return this.pageStore.loading;
        },
        categoryPagesPaginated() {
            return this.pageStore.categoryPagesPaginated;
        }
    },
    methods: {
        initialize() {
            const filter = {
                key: 'category_key',
                match: this.key
            };

            this.pageStore.defineFilterValue({ key: 'category_key', value: filter });
            // this.pageStore.definePathValue(this.key);
            this.pageStore.defineLinkValue(`/post/${this.key}/`);
            this.pageStore.updateLoading(true);
            this.refetch();
        },
        addCategoryPage() {
            const params = { key: this.key, id: 'new' };
            router.push({ name: 'post-main', params });
        },
        handleSizeChange(itemsPerPage) {
            this.pageStore.updateLoading(true);
            this.pageStore.defineItemsPerPage(itemsPerPage);
            this.refetch();
        },
        handleCurrentChange(currentPage) {
            this.pageStore.updateLoading(true);
            this.pageStore.defineCurrentPage(currentPage);
            this.refetch();
        },
        handleColsShow(visibleColumns) {
            this.pageStore.defineActiveColumns(visibleColumns);
            // apolloClient.cache.reset()
            apolloClient.clearStore();
        },
        handleFilterInputChange(key, value, debounce = true) {
            this.pageStore.defineFilterValue({ key, value });
            if (debounce) this.debouncedRefetch();
            else this.refetch();
        },
        handleSortInputChange(key, value) {
            this.pageStore.defineSorting({ key, value });
            this.refetch();
        },
        toggleFilterVisiblity() {
            const visible = this.showFilters;

            let value = false;
            if (!visible) value = true;

            this.disable.showFilters = true;
            this.pageStore.defineFilterVisibility(value);
            // this.saveFilterVisibility({ scope: 'cp', key: this.key, value })
            this.saveFilterVisibility({ scope: 'cp', key: 'page', value }).finally(
                () => (this.disable.showFilters = false)
            );
        },
        refetch() {
            // always add the cms id to filters
            const cmsID = this.activeCms.id;
            if (cmsID) {
                const filter = {
                    key: 'cms',
                    match: cmsID
                };
                this.pageStore.defineFilterValue({ key: 'cms', value: filter });

                this.pageStore.fetchCategoryPagesPaginated()
                    .then(() => this.pageStore.updateLoading(false))
                    .catch(err => {
                        const { graphQLErrors } = err

                        let code = 501;
                        let message = 'An error occurred!';

                        if (graphQLErrors) {
                            code = _.get(graphQLErrors, '0.code') || code;
                            message = _.get(graphQLErrors, '0.message') || message;
                        }

                        let notify = true;
                        switch (code) {
                            case 401:
                                notify = false;
                                this.error = { code, message: 'You are not authorized' };
                                break;
                            case 403:
                                notify = false;
                                this.error = { code, message: 'You are not allowed to be here' };
                                break;
                            // case 404:
                            //     break;
                            default:
                                this.error = true;
                                break;
                        }

                        if (notify) {
                            this.$notify.error({
                                title: this.$t(message),
                                message: this.$t('Post list could not be fetched.'),
                                iconClass: 'fas el-icon-fa-xmark',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });
                        }

                        this.pageStore.updateLoading(false);

                        /* eslint no-console: ["error", { allow: ["error"] }] */
                        console.error(err);
                    })
            }
        },
        debouncedRefetch: _.debounce(function() {
            // function scope is needed here
            this.pageStore.updateLoading(true);
            this.refetch();
        }, useSetupStore(pinia).debounce || 300),
        resetFiltersModal() {
            this.$refs.filtersModal.resetFields();
            // this.$set(this.filtersModal.form, 'filters', []);
            this.filtersModal = {
                visibility: false,
                loading: false,
                remove: [],
                form: {
                    filters: [],
                    filter: {
                        name: '',
                        key: ''
                    }
                }
            }
        },
        fetchFilters() {
            const cmsID = _.get(this.activeCms, 'id', null);
            const category_key = this.key;
            const category = this.activeCms.categories.find(category => category.key === category_key);
            if (category && category.id && cmsID) {
                const category_id = category.id;
                CategoryFiltersAPI.fetchList(cmsID, category_id)
                    .then((data) => {
                        // TODO: rules
                        this.$set(this.filtersModal.form, 'filters', data)
                        // this.filtersModal.form.filters = data;
                        setTimeout(() => (this.filtersModal.loading = false), 0);
                    })
                    .catch(err => {
                        this.filtersModal.visibility = false;

                        /* eslint no-console: ["error", { allow: ["error"] }] */
                        console.error(err);

                        this.$notify.error({
                            title: this.$t('An error occurred!'),
                            message: this.$t('Category filters could not be fetched.'),
                            iconClass: 'fas el-icon-fa-xmark',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                    });
            }else {
                this.filtersModal.loading = false;
            }
        },
        openNewFilterModal() {
            this.filtersModal.loading = true;
            this.filtersModal.visibility = true;
            this.fetchFilters();
        },
        removeFilters() {
            if (this.filtersModal.remove && this.filtersModal.remove.length > 0) {
                let actions = [];
                this.filtersModal.remove.forEach(filter => {
                    if (filter && filter.id) actions.push(
                        CategoryFiltersAPI.delete(filter)
                            .then(() => {
                                this.toggleFilterRemoval(filter)
                                this.removeFilter(filter)
                            })
                    )
                });

                Promise.all(actions)
                    .then(() => {
                        this.$notify.success({
                            title: this.$t('Update successfull!'),
                            message: this.$t('Category filter was deleted successfully.'),
                            iconClass: 'fas el-icon-fa-check',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                        // this.fetchFilters();
                    })
                    .catch(err => {
                        this.filtersModal.visibility = false;

                        /* eslint no-console: ["error", { allow: ["error"] }] */
                        console.error(err);

                        this.$notify.error({
                            title: this.$t('An error occurred!'),
                            message: this.$t('Category filters could not be fetched.'),
                            iconClass: 'fas el-icon-fa-xmark',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                    });

                let wait = this.filtersModal.remove.length > 5 ? 500 : 100 * this.filtersModal.remove.length
                setTimeout(() => (this.fetchFilters()), wait)
            }
        },
        closeNewFilterModal() {
            // this.resetCategoryFilters();
            this.filtersModal.visibility = false;
        },
        appendFilterItem() {
            this.$refs.filtersModal.validate(valid => {
                if (valid) {
                    let isDuplicate = false;
                    if (this.filtersModal.form.filters.find(filter => {
                        return filter.key === slugify(this.filtersModal.form.filter.name.toLowerCase())
                    })) {
                        isDuplicate = true;
                    }
                    if (isDuplicate) {
                        this.$notify.error({
                            title: this.$t('An error occurred!'),
                            message: this.$t('Category filter already exists.'),
                            iconClass: 'fas el-icon-fa-xmark',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                        this.filtersModal.form.filter = {
                            key: '',
                            name: '',
                        }
                    } else {
                        const id = uniqid('new:');
                        this.filtersModal.form.filter.id = id;
                        this.filtersModal.form.filter.key = slugify(this.filtersModal.form.filter.name.toLowerCase());

                        const categoryKey = this.key;
                        const category = this.activeCms.categories.find(category => category.key === categoryKey);
                        const categoryID = category.id;
                        const cmsID = _.get(this.activeCms, 'id', null);
                        this.filtersModal.form.filter.categories = [{ id: categoryID }];
                        this.filtersModal.form.filter.cms = { id: cmsID };
                        let filter = this.filtersModal.form.filter;

                        this.filtersModal.form.filter = {
                            key: '',
                            name: '',
                        }

                        if (filter.key && filter.name) {
                            // this.filtersModal.form.filters.push(filter)
                            CategoryFiltersAPI.create(filter)
                                .then((data) => {
                                    this.$notify.success({
                                        title: this.$t('Update successfull!'),
                                        message: this.$t('Category filter was added successfully.'),
                                        iconClass: 'fas el-icon-fa-check',
                                        position: 'bottom-left',
                                        customClass: 'dark',
                                        duration: 8000
                                    });
                                    this.fetchFilters();
                                })
                                .catch(err => {
                                    this.filtersModal.visibility = false;

                                    /* eslint no-console: ["error", { allow: ["error"] }] */
                                    console.error(err);

                                    this.$notify.error({
                                        title: this.$t('An error occurred!'),
                                        message: this.$t('Category filter could not be saved.'),
                                        iconClass: 'fas el-icon-fa-xmark',
                                        position: 'bottom-left',
                                        customClass: 'dark',
                                        duration: 8000
                                    });
                                });
                        }
                    }

                    // this.closeNewFilterModal();
                }
            });
        },
        toggleFilterRemoval(filter) {
            if (this.filtersModal.remove.includes(filter)) {
                const index = _.findIndex(this.filtersModal.remove, filter);
                if (index >= 0) this.filtersModal.remove.splice(index, 1);
            } else {
                this.filtersModal.remove.push(filter);
            }
        },
        removeFilter(filter) {
            const index = _.findIndex(this.filtersModal.form.filters, filter);
            if (index >= 0) this.filtersModal.form.filters.splice(index, 1);
        },
        activateTab(item) {
            return useSetupStore().activateTab(item);
        },
        saveFilterVisibility(payload) {
            return useSetupStore().saveFilterVisibility(payload);
        },
        getPostPublicUrl(item) {
            const baseUrl = _.get(this.activeCms, 'domains.0.base_url', '');
            const categoryKey = this.key;
            const slug = _.get(item, 'key', '');

            if (!baseUrl || !categoryKey || !slug) return '';

            let protocol = 'http:';
            if (process.env.NODE_ENV === 'production') protocol = window.location.protocol;

            const normalizedBaseUrl = String(baseUrl)
                .replace(/^https?:\/\//, '')
                .replace(/\/+$/, '');
            const normalizedCategoryKey = String(categoryKey).replace(/^\/+|\/+$/g, '');
            const normalizedSlug = String(slug).replace(/^\/+|\/+$/g, '');

            return `${protocol}//${normalizedBaseUrl}/${normalizedCategoryKey}/${normalizedSlug}`;
        },
        parseTimestamp(value) {
            if (value === undefined || value === null || value === '') return null;

            const numeric = Number(value);
            if (!Number.isNaN(numeric)) {
                return numeric > 9999999999 ? numeric : numeric * 1000;
            }

            const date = new Date(value);
            if (Number.isNaN(date.getTime())) return null;
            return date.getTime();
        },
        isPostActive(item) {
            const now = Date.now();
            const publishStart = this.parseTimestamp(_.get(item, 'publish_start'));
            const publishEnd = this.parseTimestamp(_.get(item, 'publish_end'));

            let isActive = true;
            if (publishStart !== null && isActive) isActive = now > publishStart;
            if (publishEnd !== null && isActive) isActive = now < publishEnd;

            return isActive;
        },
        postStatusClass(item) {
            return this.isPostActive(item) ? 'is-active' : 'is-inactive';
        },
        postStatusLabel(item) {
            return this.isPostActive(item) ? this.$t('Active') : this.$t('Inactive');
        },
        openPostPreview(item) {
            const url = this.getPostPublicUrl(item);
            if (!url) return;
            this.previewDrawer.visibility = true;
            this.previewDrawer.loading = true;

            this.$nextTick(() => {
                const urlObj = new URL(url);
                urlObj.searchParams.set('no-cache', 'true');
                this.previewDrawer.src = urlObj.toString();
                this.previewDrawer.loading = false;
            });
        },
        resetPreviewModal() {
            this.previewDrawer = {
                visibility: false,
                src: undefined,
                loading: false
            };
        },
        async copyPostLink(item) {
            const url = this.getPostPublicUrl(item);
            if (!url) return;

            try {
                if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
                    await navigator.clipboard.writeText(url);
                } else {
                    copy(url);
                }
                this.$message.success(this.$t('Post link copied to clipboard!'));
            } catch (e) {
                try {
                    copy(url);
                    this.$message.warning(this.$t('Post link copied to clipboard!'));
                } catch (fallbackError) {
                    this.$message.error(this.$t('Post link could not be copied.'));
                }
            }
        },
        confirmDeletePost(item) {
            const id = _.get(item, 'id');
            if (!id) return;

            const postTitle = String(_.get(item, 'title', '')).trim() || `#${id}`;

            this.$confirm(
                this.$t('Do you really want to delete "{title}"?', { title: postTitle }),
                this.$t('Delete post'),
                {
                    confirmButtonText: this.$t('Delete'),
                    cancelButtonText: this.$t('Cancel'),
                    type: 'warning'
                }
            )
                .then(() => {
                    this.pageStore.updateLoading(true);
                    return PageApi.delete(id)
                        .then(() => {
                            this.$notify.success({
                                title: this.$t('Post deleted successfully.'),
                                iconClass: 'fas el-icon-fa-check',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });

                            this.refetch();
                        })
                        .catch((err) => {
                            /* eslint no-console: ["error", { allow: ["error"] }] */
                            console.error(err);

                            this.$notify.error({
                                title: this.$t('An error occurred!'),
                                message: this.$t('Post could not be deleted.'),
                                iconClass: 'fas el-icon-fa-xmark',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });

                            this.pageStore.updateLoading(false);
                        });
                })
                .catch(() => {
                    // canceled by user
                });
        }
    },
    beforeRouteEnter(to, from, next) {
        let cms = useSetupStore(pinia).activeCms;
        const categories = _.get(cms, 'config.template.categories') || [];
        const keys = _.map(categories, 'key');

        if (!keys.length) next({ name: 'dashboard' });
        else {
            // redirect if necessary
            let key = _.get(to, 'params.key');
            if (!key || key === '#' || !keys.includes(key)) {
                key = keys[0];
                next({ name: 'posts', params: { key } });
            } else {
                next();
            }
        }
    },
    beforeRouteUpdate(to, from, next) {
        next();
        this.initialize();
    },
    mounted() {
        this.initialize();
    }
};
</script>
<style lang="sass" scoped>
    .post-title-with-status
        display: inline-flex
        align-items: center
        gap: 8px

    .status-dot
        width: 10px
        height: 10px
        border-radius: 50%
        display: inline-block
        flex-shrink: 0
        &.is-active
            background-color: #67c23a
        &.is-inactive
            background-color: #f56c6c

    .pull-left
        float: left
    .delete-warning
        margin-bottom: 1rem
        // max-width: 50%
        text-align: left
    .error
        padding: 20px
    .category-filters
        margin-bottom: 20px
    .mb-1
        display: block
        margin-bottom: 0.5rem
    .mt-0
        margin-top: 0
</style>
